export const templates = [
  { id: 1, name: 'Bricks', url: '/templates/brick.png' },
  { id: 2, name: 'Neon Night', url: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?w=800' },
  { id: 3, name: 'Day moon', url: '/templates/day_moon.png' },
  { id: 5, name: 'Minimalist', url: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=800' },
  { id: 6, name: 'Leaves', url: '/templates/Leaves.png' },
  { id: 7, name: 'Woody', url: '/templates/woody.png' },
];